import { useDeepCompareEffect, useMemoizedFn } from "ahooks";
import { omitBy, isNil } from "lodash";
import { useRouter } from "next/router";
import { useState } from "react";

/**
 * 通过 url query 来管理 state 的 Hook。
 * @param {	S | () => S} initialState
 * @param {{
 *  navigateMode: 'push' | 'replace',
 * }} options
 * @returns {[S, (S)=>void]}
 */
export default function useUrlState(initialState = {}, options = {}) {
  const { navigateMode = "push" } = options;
  const router = useRouter();
  const [state, setState] = useState({ ...initialState, ...router.query });

  const changeState = useMemoizedFn((next) => {
    const nextState = omitBy(
      {
        ...router.query,
        ...next,
      },
      isNil
    );
    router[navigateMode]({
      query: nextState,
    });

    setState(nextState);
  });

  // 监听路由变化
  useDeepCompareEffect(() => {
    setState({
      ...initialState,
      ...router.query,
    });
  }, [router.query, initialState]);

  return [state, changeState];
}
